export enum PaymentMethodTypeEnum {
  CASH= 'CASH',
  DEPOSIT_TO_ACCOUNT = 'DEPOSIT_TO_ACCOUNT',
  CHEQUE = 'CHEQUE'
}
